import { TuiFileLike } from '@taiga-ui/kit';

export enum ProductDialogStep {
  Common = 'common',

  Contacts = 'contacts',

  Terms = 'terms',
}

export type TuiFileLikeWithId = TuiFileLike & {
  /** Идентификатор файла */
  id?: string;
};
